import { useState, useMemo, useCallback, useEffect } from 'react';
import { RoomTask } from 'src/common/interfaces/tasks';
import { isTaskBreakdownRoom } from '../helpers';
export const useTaskBreakdown = ({
  roomCode,
  tasks
}: {
  roomCode: string;
  tasks?: RoomTask[];
}) => {
  const [currentTask, setCurrentTask] = useState<RoomTask>();
  const sortedTasks = useMemo(() => [...(tasks || [])].sort((task1, task2) => task1.taskNo - task2.taskNo), [tasks]);
  useEffect(() => {
    if (!currentTask) {
      setCurrentTask(sortedTasks.find(t => t.questions.find(q => !q.progress?.correct)) || sortedTasks[sortedTasks.length - 1]);
    }
  }, [currentTask, sortedTasks]);
  const advanceToNextTask = useCallback(() => setCurrentTask(sortedTasks.find(t => currentTask && t.taskNo === currentTask.taskNo + 1)), [currentTask, sortedTasks]);
  const resetToFirstTask = useCallback(() => setCurrentTask(sortedTasks[0]), [sortedTasks]);
  return {
    currentTask: sortedTasks.find(t => t.taskNo === currentTask?.taskNo),
    advanceToNextTask,
    resetToFirstTask,
    isTaskBreakdownSupported: isTaskBreakdownRoom(roomCode),
    isLastTask: tasks && currentTask ? currentTask.taskNo === sortedTasks[tasks.length - 1]?.taskNo : false
  };
};